import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Image,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';

import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';
import { DatePicker, Tooltip, Tree } from 'antd';
import moment from 'moment';
import queryString from 'query-string';

import BaseMultipleSelectorDropDown from 'components/base/BaseMultipleSelectorDropDown';
import 'components/customer/Filter.scss';
import {
  CustomNumberInput,
  CustomStringInput,
  CustomTitleLabel,
} from 'components/earning/CustomBaseComponments';

import { removeElementFromArray } from 'utils';
import { TimeFormater } from 'utils/TimeFormatUtil';

import addImage from 'assets/images/Addclose.svg';
import openImage from 'assets/images/Addopen.svg';
import backImage from 'assets/images/Vectorback.svg';
import CheckedRadio from 'assets/images/checked_radio.svg';
import Info from 'assets/images/info.svg';
import UncheckedRadio from 'assets/images/unchecked_radio.svg';

import filterCollapsed from 'assets/images/filter_collapsed.svg';
import filterExpanded from 'assets/images/filter_expanded.svg';

import './BaseFilter.scss';

const { RangePicker } = DatePicker;

const ImageButton = ({ action, image }) => {
  //   const [buttonImage, setButtonImage] = useState(addImage);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <button
      className="custom-image-button create-section-label-bottom-space filter-open-button-margin"
      onClick={() => {
        action();
        // setButtonImage();
        setIsOpen(!isOpen);
      }}
    >
      <Image src={image ? image : isOpen ? openImage : addImage} />
    </button>
  );
};
export const CheckboxItem = ({
  index,
  title,
  defaultValue,
  onChange,
  needNoMargin = true,
  toolTips = false,
}) => {
  return (
    <label
      className={`checkbox-container ${index === 0 && needNoMargin ? 'checkbox-container-no-margin' : ''
        }`}
    >
      {toolTips ?
        <Tooltip placement="topLeft" title={title}>
          {title}
        </Tooltip>
        : title
      }
      <input type="checkbox" checked={defaultValue} onChange={onChange} />
      <span className="checkmark"></span>
    </label>
  );
};

const FilterItems = ({ title, data, value = [], setValue, className }) => {
  const [show, setShow] = useState(!title || false);
  const [checked, setChecked] = useState(value);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  useEffect(() => {
    setValue(checked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <>
      {title ? (
        <div className="filter_choice_title_area">
          <CustomTitleLabel title={title} className={'filter_choice_title'} />
          <ImageButton
            action={() => {
              setShow(!show);
            }}
          />
        </div>
      ) : null}

      {show ? (
        <div
          className={`d-flex flex-column filter-list-items-area ${className}`}
          style={{ minHeight: '30px' }}
        >
          {data?.map((item, index) => {
            return (
              <CheckboxItem
                index={index}
                title={item.name}
                defaultValue={checked.indexOf(item.pk) > -1}
                onChange={() => {
                  if (checked.includes(item.pk)) {
                    const newCheckedData = removeElementFromArray(
                      checked,
                      item.pk,
                    );
                    setChecked(newCheckedData);
                  } else {
                    setChecked([...checked, item.pk]);
                  }
                }}
              />
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export const RadiosItem = ({
  index,
  title,
  selected,
  onChange,
  needNoMargin = true,
  toolTips = null,
}) => {
  return (
    <div
      className={`d-flex flex-row checkbox-container ${index === 0 && needNoMargin ? 'checkbox-container-no-margin' : ''
        }`}
      onClick={onChange}
    >
      <Image
        src={selected ? CheckedRadio : UncheckedRadio}
        className="radio-select-button"
      />
      {title}
      {toolTips ? (
        <OverlayTrigger
          trigger="hover"
          placement="right"
          overlay={
            <Popover id="popover-basic" className="caution-container">
              <Popover.Content className="caution-content">
                <ul>
                  {toolTips.split('\n').map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </Popover.Content>
            </Popover>
          }
        >
          <div className="d-flex align-self-end tips-input-count-icon">
            <Image src={Info} className={'caution-icon'} />
          </div>
        </OverlayTrigger>
      ) : null}
    </div>
  );
};

const FilterItemsSingleChoice = ({
  title,
  data,
  value,
  setValue,
  className,
}) => {
  const [show, setShow] = useState(false);
  // const [checked, setChecked] = useState(value);

  // useEffect(() => {
  //   setChecked(value);
  // }, [value]);

  // useEffect(() => {
  //   setValue(checked);
  // }, [checked]);

  return (
    <>
      <div style={{ display: 'flex' }}>
        <CustomTitleLabel title={title} />
        <ImageButton
          action={() => {
            setShow(!show);
          }}
        />
      </div>
      {show
        ? (
          <div className={`d-flex flex-column filter-list-items-area ${className}`} >
            {data?.map((item, index) => {
              return (
                <>
                  <RadiosItem
                    index={index}
                    title={item.name}
                    selected={value === item.pk}
                    onChange={() => {
                      if (value === item.pk) {
                        setValue();
                      } else {
                        setValue(item.pk);
                      }
                    }}
                  />
                  {value === item.pk && item.subComponment
                    ? (
                      <item.subComponment.component
                        className={item.subComponment.className}
                        data={item.subComponment.data}
                        value={item.subComponment.value}
                        setValue={item.subComponment.setValue}
                      />
                    )
                    : null}
                </>
              );
            })}
          </div>
        )
        : null}
    </>
  );
};

const ExtendableFilterItemsSingleChoice = ({
  title,
  data,
  value,
  setValue,
  className,
}) => {
  const checkedPks = [];
  (data || []).forEach((item) => {
    if (value === item.pk) {
      (item.subComponment?.value || []).forEach((pk) => {
        const key = `${item.pk}-${pk}`;
        checkedPks.push(key);
      });
    }
  });
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checked, setChecked] = useState(checkedPks);
  // const [selectedKeys, setSelectedKeys] = useState([]);
  // const selectedKeys = []
  const [show, setShow] = useState(false);

  const expand = (node) => {
    const expanded = node.expanded;
    const hasChildren = (node.children || []).length > 0;
    const key = node.key;
    console.log('expanded', key, expanded);
    if (hasChildren) {
      if (expanded) {
        setExpandedKeys([]);
      } else {
        setExpandedKeys([key]);
      }
    } else {
      if (node.checked) {
        const newCheckedKeys = checked.filter(
          (item) => item !== node.key && item !== node.key.split('-', 1)?.[0])
        setChecked(newCheckedKeys)
        updateValue(newCheckedKeys);
      } else {
        const level1Key = key.split('-', 1);
        const newCheckedKeys = [];
        checked.forEach(s => {
          if (s.startsWith(level1Key)) {
            newCheckedKeys.push(s);
          }
        });
        newCheckedKeys.push(node.key)
        setChecked(newCheckedKeys);
        updateValue(newCheckedKeys);
      }
    }
  };

  const onExpand = (expandedKeysValue, info) => {
    console.log('onExpand', expandedKeysValue, info);
    expand(info.node);
  };

  const onSelect = (selectedKeys, info) => {
    console.log('selected', selectedKeys, info);
    expand(info.node);
  };

  const updateValue = (keys) => {
    let group = '';
    const pks = [];
    (keys || []).forEach((key) => {
      if (key.indexOf('-') > 0) {
        const [key1, key2] = key.split('-', 2);
        console.log(key, key1, key2);
        group = key1;
        pks.push(key2);
      }
    });
    console.log(group, pks);
    setValue(group);
    (data || []).forEach(item => {
      if (item.pk !== group) {
        // item.subComponment.setValue([]);
        return;
      }
      console.log('@313', group, pks);
      item.subComponment.setValue(pks);
    });
  };

  const onCheck = (checkedKeys, info) => {
    console.log('onCheck', checkedKeys, info);
    const hasChildren = (info.node.children || []).length > 0;
    const key = info.node.key;
    const checked = info.checked;
    console.log('onCheck', key, checked);
    if (checked) {
      const level1Key = hasChildren ? key : key.split('-', 1);
      const newCheckedKeys = [];
      checkedKeys.forEach(s => {
        if (s.startsWith(level1Key)) {
          newCheckedKeys.push(s);
        }
      });
      setChecked(newCheckedKeys);
      updateValue(newCheckedKeys);
    } else {
      setChecked(checkedKeys);
      updateValue(checkedKeys);
    }
  };

  let treeData = [];

  (data || []).forEach(item => {
    const level1Item = {
      title: item.name,
      key: item.pk,
      children: [],
    };
    (item.subComponment.data || []).forEach(item2 => {
      const level2Item = {
        title: item2.name,
        key: `${item.pk}-${item2.pk}`,
      };
      level1Item.children.push(level2Item);
    });
    treeData.push(level1Item);
  });


  return (
    <>
      <div style={{ display: 'flex' }}>
        <CustomTitleLabel title={title} />
        <ImageButton
          action={() => {
            setShow(!show);
          }}
        />
      </div>
      {show
        ? (
          <div
            className={`d-flex flex-column filter-list-items-area extendable-filter-items-single-choice ${className}`}
          >
            <Tree
              checkable
              onExpand={onExpand}
              expandedKeys={expandedKeys}
              defaultExpandAll={false}
              onSelect={onSelect}
              // selectedKeys={selectedKeys}
              onCheck={onCheck}
              checkedKeys={checked}
              treeData={treeData}
            />
          </div>
        )
        : null}
    </>
  );
};

const FilterSegment = ({ title, data, value, setValue }) => {
  return (
    <>
      <CustomTitleLabel title={title} />
      <ButtonGroup className="filter-button-group">
        {data.map((item, index) => {
          return (
            <Button
              className={`filter-button-group-item ${value.includes(item.pk) ? 'filter-button-selectd' : ''
                } filter-button-selectd-${index}`}
              onClick={() => {
                if (value.includes(item.pk)) {
                  console.log('@@192: remove');
                  setValue(removeElementFromArray(value, item.pk));
                } else {
                  console.log('@@192: add');
                  setValue([...value, item.pk]);
                }
              }}
            >
              {item.name}
            </Button>
          );
        })}
      </ButtonGroup>
    </>
  );
};

const FilterSingle = ({ title, data, value, setValue }) => {
  return (
    <>
      <CustomTitleLabel title={title} />
      <ButtonGroup className="filter-button-group">
        {data.map((item, index) => {
          return (
            <Button
              className={`filter-button-group-item ${value === item.pk ? 'filter-button-selectd' : ''
                } filter-button-selectd-${index}`}
              onClick={() => {
                if (value === item.pk) {
                  setValue();
                } else {
                  setValue(item.pk);
                }
              }}
            >
              {item.name}
            </Button>
          );
        })}
      </ButtonGroup>
    </>
  );
};

const FilterSlider = ({ title, data, value, setValue = () => { } }) => {
  const ageSlider = useRef();

  const PrettoSlider = withStyles({
    root: {
      color: '#4E8DD7',
      height: 1.5,
    },
    thumb: {
      height: 15,
      width: 15,
      backgroundColor: '#4E8DD7',
      marginTop: -6,
      marginLeft: -6,
    },
  })(Slider);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const handleChange = (value) => {
  //   setValue(value);
  // };

  return (
    <>
      <CustomTitleLabel title={title} />

      {/* <Slider
        range
        min={data ? data[0] : 0}
        max={data ? data[1] : 80}
        trackStyle={{ backgroundColor: '#4E8DD7' }}
        handleStyle={{ borderColor: '#4E8DD7', backgroundColor: '#4E8DD7' }}
        value={value}
        onChange={handleChange}
      /> */}
      <PrettoSlider
        value={value}
        ref={ageSlider}
        min={data ? data[0] : 0}
        max={data ? data[1] : 80}
        // getAriaValueText={valueLabelFormat}
        // valueLabelFormat={valueLabelFormat}
        onChange={handleChange}
        valueLabelDisplay="auto"
        aria-labelledby="non-linear-slider"
        className="filter-slider"
      // defaultValue={age}
      />
      <div className="display-flex-area">
        <label className="filter-age-min filter-age-font">{value[0]}</label>
        <label className="filter-age-max filter-age-font">{value[1]}</label>
      </div>
    </>
  );
};

const FilterDate = ({ title, value, setValue = () => { } }) => {
  return (
    <>
      <CustomTitleLabel title={title} />
      <DatePicker
        value={value ? moment(value, TimeFormater.yearMonthDay) : null}
        format={TimeFormater.dayMonthYearWeek}
        onChange={(date, dateString) =>
          setValue(date?.format(TimeFormater.yearMonthDay))
        }
        // popupStyle={{ position: 'fixed' }}
        getPopupContainer={(trigger) => {
          return trigger.parentNode;
        }}
      />
    </>
  );
};

const FilterDatetime = ({ title, value, setValue = () => { } }) => {
  console.log('@@291: ', value);
  return (
    <>
      <CustomTitleLabel title={title} />
      <DatePicker
        showNow={false}
        value={value ? moment(value, TimeFormater.yearMonthDayTime) : null}
        showTime={{ format: TimeFormater.timePeriod }}
        format={TimeFormater.yearMonthDayTimePeriod}
        onChange={(date, dateString) => {
          if (!dateString) {
            setValue(null);
          }
        }}
        onOk={(value) => {
          setValue(value?.format(TimeFormater.yearMonthDayTime));
        }}
        popupStyle={{ position: 'fixed' }}
      // getPopupContainer={(trigger) => {
      //   return trigger.parentNode;
      // }}
      />
    </>
  );
};

const FilterDateRange = ({ title, value, setValue = () => { } }) => {
  const dateRange = Array.isArray(value)
    ? value
    : value
      ? value.split(',')
      : [];

  // const [left, setLeft] = useState(0);
  // const [top, setTop] = useState(0);
  // const [popupContainer, setPopupContainer] = useState();

  return (
    <>
      {title ? <CustomTitleLabel title={title} /> : null}

      <div className='base-filter-date-range-picker'>
        <RangePicker
          // defaultValue={[
          //   dateRange[0]
          //     ? moment(dateRange[0], TimeFormater.yearMonthDay)
          //     : null,
          //   dateRange[1]
          //     ? moment(dateRange[1], TimeFormater.yearMonthDay)
          //     : null,
          // ]}
          defaultPickerValue={[
            dateRange[0] ? moment(dateRange[0], TimeFormater.yearMonthDay) : null,
            dateRange[1] ? moment(dateRange[1], TimeFormater.yearMonthDay) : null,
          ]}
          value={
            !value
              ? []
              : [
                dateRange[0] ? moment(dateRange[0]) : null,
                dateRange[1] ? moment(dateRange[1]) : null,
              ]
          }
          // popupStyle={{ position: 'relative' }}
          format={TimeFormater.dayMonthYearWeek}
          separator={'-'}
          onChange={(dates, dateStrings) => {
            if (dates) {
              const [start, end] = dates;
              setValue(
                start?.format(TimeFormater.yearMonthDay) +
                ',' +
                end?.format(TimeFormater.yearMonthDay),
              );
            } else {
              setValue('');
            }
          }}
        // popupStyle={{ position: 'fixed', left: left, top }}
        // getPopupContainer={(trigger) => {
        //   console.log('@@376: ', trigger);
        //   console.log('@@376-1: ', trigger?.getBoundingClientRect());
        //   // trigger.style.position = 'flex';
        //   // trigger.style.left = ''
        //   setPopupContainer(trigger);
        //   return trigger.parentNode;
        // }}
        // onOpenChange={(open) => {
        //   if (open) {
        //     console.log('@@402');
        //     setTimeout(() => {
        //       console.log('@@405');
        //       setLeft(window.innerWidth - 600);
        //       console.log('@@409: ', popupContainer);
        //       setTop(popupContainer?.getBoundingClientRect().top);
        //     }, 500);
        //   } else {
        //     setLeft(0);
        //     setTop(0);
        //   }
        // }}
        />
      </div>
    </>
  );
};

const FilterInput = ({ value, setValue }) => {
  return <CustomNumberInput defaultValue={value} setValue={setValue} />;
};

const FilterInputWithTitle = ({ title, placeholder, value, setValue }) => {
  return (
    <CustomStringInput
      title={title}
      placeholder={placeholder}
      defaultValue={value}
      setValue={setValue}
    />
  );
};

const FilterInputNumberRange = ({ title, value, setValue, leftPlaceholder = "Minimum", rightPlaceHolder = "Maximum" }) => {
  const [minNumber, setMinNumber] = useState()
  const [maxNumber, setMaxNumber] = useState()

  useEffect(() => {
    setMinNumber(value?.[0])
    setMaxNumber(value?.[1])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (value?.length < 1) {
      setMaxNumber("")
      setMinNumber("")
    }
  }, [value])

  useEffect(() => {
    if (!minNumber && !maxNumber) {
      setValue()
      return;
    }
    setValue(`${minNumber || ""},${maxNumber || ""}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minNumber, maxNumber])

  return (
    <div className='number-range-input-section-spacing'>
      <label className='create-section-label'>
        {title}
      </label>
      <div className='number-range-input'>
        <input
          placeholder={leftPlaceholder}
          type='number'
          value={minNumber}
          onChange={(e) => {
            setMinNumber(e.target.value)
          }}
        />
        <div>{"-"}</div>
        <input
          placeholder={rightPlaceHolder}
          type='number'
          value={maxNumber}
          onChange={(e) => {
            setMaxNumber(e.target.value)
          }}
        />
      </div>

    </div>
  )
}

export const FilterTypeEnum = {
  choice: FilterItems,
  segment: FilterSegment,
  slider: FilterSlider,
  date: FilterDate,
  dateRange: FilterDateRange,
  singleChoiceSegment: FilterSingle,
  singleChoice: FilterItemsSingleChoice,
  singleChoiceTargetCustomer: ExtendableFilterItemsSingleChoice,
  input: FilterInput,
  inputWithTitle: FilterInputWithTitle,
  datetime: FilterDatetime,
  multipleSelectorDropdown: BaseMultipleSelectorDropDown,
  inputNumberRange: FilterInputNumberRange,
};

const resetContent = (
  content
) => {
  content.forEach((item) => {
    switch (item.component) {
      case FilterTypeEnum.date:
      case FilterTypeEnum.datetime:
        item.setValue(null);
        break;
      case FilterTypeEnum.dateRange:
      case FilterTypeEnum.inputWithTitle:
      case FilterTypeEnum.inputNumberRange:
        item.setValue('');
        break;
      case FilterTypeEnum.singleChoice:
      case FilterTypeEnum.singleChoiceTargetCustomer:
        item.setValue();

        item.data.forEach((val) => {
          if (val.subComponment) {
            val.subComponment.setValue();
          }
        });
        break;
      case FilterTypeEnum.slider:
        item.setValue([0, 0]);
        break;
      default:
        item.setValue([]);
        break;
    }
  });
};

const getSearchFromContent = (
  content,
) => {
  let search = {};

  content.forEach((item) => {
    if (item.hide) {
      return
    };

    // custom filter key
    const key = item?.customFilterKey || item?.title?.toLowerCase().replace(/ /g, '_');
    const value = item.value;

    switch (item.component) {
      case FilterTypeEnum.date:
      case FilterTypeEnum.dateRange:
      case FilterTypeEnum.datetime:
      case FilterTypeEnum.singleChoiceSegment:
      case FilterTypeEnum.inputWithTitle:
      case FilterTypeEnum.inputNumberRange:
        if (value) {
          search[key] = value;
        }
        break;
      case FilterTypeEnum.singleChoice:
      case FilterTypeEnum.singleChoiceTargetCustomer:
        if (value) {
          search[key] = value;
        }

        item.data.forEach((val) => {
          if (val.pk === value && val.subComponment) {
            if (
              val.subComponment.component === FilterTypeEnum.choice
              && val.subComponment.value.length > 0
            ) {
              search[value] = val.subComponment.value.join(',');
            } else {
              search[value] = val.subComponment.value;
            }
          }
        });

        break;
      case FilterTypeEnum.slider:
        if (value[1] > 0) {
          search[key] = value.join(',');
        }
        break;
      case FilterTypeEnum.multipleSelectorDropdown:
        if (value?.length > 0) {
          const searchKey = key || item?.filterTitle?.toLowerCase().replace(/ /g, '_');
          search[searchKey] = value.map((item) => (item?.value?.pk)).join(',')
        }
        break;
      case undefined:
        break;
      default:
        if (value.length > 0) {
          search[key] = value.join(',');
        }
        break;
    }
  });

  return search;
};

const SingleBaseFilterSection = ({
  customSectionClassName,
  sectionName,
  content,
  collapsed = false,
  setCollapsed = () => { },
}) => {
  return (
    <div className={`single-base-filter-section ${customSectionClassName}`}>
      {
        sectionName
          ? <div
            className='single-base-filter-section-name-container'
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          >
            <Image
              src={collapsed ? filterCollapsed : filterExpanded}
              className="single-base-filter-section-name-image"
            />
            <span className='single-base-filter-section-name'>{sectionName}</span>
          </div>
          : null
      }

      {content.map((item) => {
        if (collapsed || item.hide) {
          return null;
        };

        if (item.customComponment) {
          return (
            <>
              {item.customComponment}
              <div className="filter-menu-border" />
            </>
          );
        };

        return (
          <>
            <item.component
              title={item.title}
              className={item.className || ''}
              data={item.data}
              value={item.value}
              setValue={item.setValue}
              source={item.data}
              onChange={item.setValue}
              filterTitle={item.filterTitle}
              loadMoreAction={item.loadMoreAction}
              filterAction={item.filterAction}
              placeholder={item.placeholder}
              customItem={item.customItem}
              defaultFilter={item.defaultFilter}
              hideFilterTitle={item.hideFilterTitle}
              hasMarginTop={false}
            />
            <div className="filter-menu-border" />
          </>
        );
      })}
    </div>
  )
};

function BaseFilter({
  content = [],
  backAction = () => { },
  customFilterClassName,
  sectionName,
  customSectionClassName,
  collapsed,
  setCollapsed = () => { },
  otherSectionContent = [],
}) {
  /** 
   * otherSectionContent example:
   * [
   *   {
   *     sectionName: "",
   *     customSectionClassName: "",
   *     content: [],
   *     collapsed: false,
   *     setCollapsed: () => {},
   *   },
   * ]
  */

  const history = useHistory();
  const location = useLocation();
  const parsedSearch = queryString.parse(location.search);

  const reset = () => {
    resetContent(content);
    otherSectionContent.forEach(section => {
      if (section.content) {
        resetContent(section.content);
      }
    })
  };

  return (
    <div className={`filter-area ${customFilterClassName}`} >
      <div style={{ display: 'grid', width: '100%', height: 'fit-content' }}>
        <div className='filter-area-filter-title-container' style={{ display: 'flex' }}>
          <label className="create-section-title">Filter</label>
          <ImageButton
            action={() => {
              // backAction();

              let search = getSearchFromContent(content);
              otherSectionContent.forEach(section => {
                if (section.content) {
                  search = {
                    ...search,
                    ...getSearchFromContent(section.content),
                  }
                }
              })

              const customSearch = backAction();

              history.push({
                pathname: location.pathname,
                hash: location.hash,
                search: queryString.stringify({
                  page: 1,
                  rank: parsedSearch['rank'],
                  search: parsedSearch['search'],
                  ...search,
                  ...(customSearch ? customSearch : {}),
                }),
              });
            }}
            image={backImage}
          />
        </div>

        <button
          type="button"
          className="btn-link filter-reset-button"
          onClick={reset}
        >
          Reset All
        </button>

        <SingleBaseFilterSection
          customSectionClassName={customSectionClassName}
          sectionName={sectionName}
          content={content}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        {
          otherSectionContent.map(section => (
            <SingleBaseFilterSection
              customSectionClassName={section.customSectionClassName}
              sectionName={section.sectionName}
              content={section.content}
              collapsed={section.collapsed}
              setCollapsed={section.setCollapsed}
            />
          ))
        }

      </div>
    </div>
  );
}

export default BaseFilter;
